import type { LandingPageContent } from '../types'

export const MONTAJE_PANELES_SOLARES: LandingPageContent = {
  slug: 'montaje-paneles-solares',
  lang: 'es',
  topicId: 'pv-module-montage',
  title: 'Montaje de paneles solares – sin sistema completo',
  metaDescription:
    '¿Ya tiene sus paneles solares? Solicite solo el montaje en el tejado - las empresas ofertan ' +
    'sin compromiso, usted compara gratis.',
  keywords: [
    'montaje paneles solares',
    'precio montaje placas solares',
    'montaje en tejado fotovoltaica',
    'instalar paneles solares sin material',
    'buscar instalador para montaje placas solares',
    'repowering fotovoltaica',
    'cambiar paneles solares viejos por nuevos',
    'ampliar instalación fotovoltaica',
    'paneles solares adicionales',
  ],
  eyebrow: 'Solo montaje, sin paquete completo',
  h1: 'Montaje de paneles solares – también sin sistema completo',
  intro:
    'No todo el mundo necesita un paquete completo: algunas personas ya han comprado los paneles o ' +
    'quieren conseguirlos por su cuenta, y solo buscan una empresa instaladora para el montaje ' +
    'profesional en el tejado. Para eso existe en Roofora un tipo de solicitud propio - "montaje en el ' +
    'tejado" en lugar de "sistema completo con montaje/instalación".',
  sections: [
    { type: 'heading', text: 'Para quién merece la pena una solicitud de solo montaje' },
    {
      type: 'list',
      items: [
        'Ya ha comprado los paneles (por ejemplo, a través de otro proveedor) y solo necesita el montaje',
        'Quiere conseguir el material usted mismo para ahorrar costes o usar una marca concreta',
        'Está ampliando una instalación ya existente y solo necesita mano de obra adicional',
      ],
    },
    { type: 'heading', text: '¿Quién aporta el material?' },
    {
      type: 'paragraph',
      text:
        'Usted decide al hacer la solicitud si aporta el material de montaje o si lo consigue la ' +
        'empresa instaladora - ambas opciones son posibles, solo tiene que indicarlo en la solicitud.',
    },
    { type: 'heading', text: 'Así funciona una solicitud de montaje en el tejado' },
    {
      type: 'paragraph',
      text:
        'Igual que en una solicitud completa, usted crea una solicitud anónima con fotos del tejado, ' +
        'orientación y el número de paneles o tamaño de instalación deseado. Las empresas instaladoras ' +
        'de su región ven la solicitud y presentan presupuestos sin compromiso solo para el montaje - ' +
        'no hace falta un análisis de consumo o rentabilidad, ya que usted ya conoce la configuración ' +
        'de la instalación.',
    },
    { type: 'heading', text: 'Contacto solo después de su autorización' },
    {
      type: 'paragraph',
      text:
        'También en las solicitudes de solo montaje se aplica el mismo principio que en el resto de ' +
        'Roofora: el contacto solo se produce cuando usted autoriza individualmente a una empresa ' +
        'instaladora concreta - sin autorización colectiva, sin lluvia de llamadas.',
    },
    { type: 'heading', text: 'Instalación existente: repowering y ampliación' },
    {
      type: 'paragraph',
      text:
        'Dos motivos frecuentes para una solicitud de solo montaje no tienen que ver con una ' +
        'instalación nueva, sino con una existente: el repowering (cambiar paneles solares antiguos ' +
        'por otros nuevos y más potentes) y la ampliación con paneles adicionales. En ambos casos, ' +
        'indique simplemente "material aportado por el cliente" y traiga usted mismo los paneles ' +
        'nuevos - la empresa instaladora se encarga únicamente del montaje o la sustitución, sin que ' +
        'tenga que licitar un sistema completo de nuevo.',
    },
    {
      type: 'paragraph',
      text:
        'Contexto legal en Alemania (información externa, no es asesoramiento legal): desde el ' +
        'Solarpaket I (abril de 2024) es más sencillo sustituir paneles antiguos por otros nuevos y ' +
        'más potentes en instalaciones de tejado - la tarifa de alimentación (EEG) para la potencia ' +
        'originalmente instalada normalmente se mantiene, siempre que la nueva instalación no supere ' +
        'la potencia de la anterior. Consulte los detalles aplicables a su caso directamente con su ' +
        'operador de red o un organismo competente antes de planificar.',
    },
  ],
  faq: [
    {
      q: '¿Puedo elegir libremente el tipo de panel y el fabricante si aporto el material?',
      a: 'Sí - con "material aportado por el cliente" usted trae los paneles que quiera, y la empresa instaladora se encarga únicamente del montaje profesional.',
    },
    {
      q: '¿Y si todavía no tengo un sistema completo, sino que apenas estoy planificando?',
      a: 'Entonces suele ser más adecuado el tipo de solicitud "sistema completo con montaje/instalación", que calcula automáticamente una configuración adecuada. La solicitud de solo montaje está pensada para quienes ya conocen el tamaño de su instalación.',
    },
    {
      q: 'Mi panel solar está defectuoso - ¿puedo resolverlo a través de Roofora?',
      a: 'Depende de qué se trate. Para un caso de garantía, su interlocutor es la empresa instaladora original que instaló la instalación - eso no lo gestiona Roofora. Si en cambio quiere simplemente sustituir un panel defectuoso por uno nuevo (por ejemplo, porque la empresa original ya no está disponible o quiere pedir un nuevo presupuesto), eso encaja como una solicitud normal de montaje en el tejado.',
    },
  ],
  primaryCta: { label: 'Solicitar montaje en el tejado', action: 'customer' },
  secondaryCta: { label: '¿Solo necesita la instalación eléctrica?', action: 'link', href: '/instalacion-electrica-fotovoltaica' },
  relatedLinks: [
    { label: 'Encontrar instalador fotovoltaico', href: '/encontrar-instalador-fotovoltaico' },
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: 'Planificar la instalación paso a paso', href: '/planificar-instalacion-fotovoltaica' },
  ],
}
